import type { ComponentProps } from 'react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

type StickyFooterCtaProps = Omit<ComponentProps<typeof Button>, 'asChild'> & {
  containerClassName?: string;
  contentClassName?: string;
};

export function StickyFooterCta({
  children,
  className,
  containerClassName,
  contentClassName,
  type = 'button',
  ...buttonProps
}: StickyFooterCtaProps) {
  return (
    <div
      className={cn(
        'fixed inset-x-0 bottom-0 z-50 border-t border-neutral-400 bg-cream px-6 pt-4 pb-[calc(1rem+env(safe-area-inset-bottom))]',
        containerClassName
      )}
    >
      <div className={cn('mx-auto max-w-[892px]', contentClassName)}>
        <Button type={type} className={cn('w-full text-lg', className)} {...buttonProps}>
          {children}
        </Button>
      </div>
    </div>
  );
}
